import React, { useState } from "react";
import UserMenu from "./UserMenu";
import ModeSwitch from "./ModeSwitch";
import LanguageToggle from "./LanguageToggle";
import BrandLogo from "@/components/common/BrandLogo";
import { Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import Sidebar from "./Sidebar";

export default function Topbar({ mode, setMode, showModeSwitch = true, availableModes, roles }) {
  const [open, setOpen] = useState(false);
  return (
    <header
      className="sticky top-0 z-30 flex items-center justify-between gap-3 h-16 px-4 md:px-6 border-b border-border bg-cream-50/70 backdrop-blur-md"
      data-testid="app-topbar"
    >
      <div className="flex items-center gap-3 lg:hidden">
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild>
            <button
              className="h-10 w-10 rounded-xl border border-border bg-white flex items-center justify-center"
              aria-label="Open menu"
              data-testid="mobile-menu-trigger"
            >
              <Menu className="h-5 w-5 text-ink-700" strokeWidth={1.75} />
            </button>
          </SheetTrigger>
          <SheetContent side="left" className="p-0 w-80 max-w-[85vw] bg-cream-50 border-r border-border" data-testid="mobile-menu-sheet">
            <div onClick={() => setOpen(false)}>
              <Sidebar roles={roles} mode={mode} mobile />
            </div>
          </SheetContent>
        </Sheet>
        <BrandLogo size="sm" />
        <div className="font-heading text-ink-900 tracking-tight font-semibold">Inner Compass</div>
      </div>
      <div className="flex-1" />
      <div className="flex items-center gap-3">
        {showModeSwitch && availableModes && availableModes.length > 1 && (
          <ModeSwitch value={mode} onChange={setMode} availableModes={availableModes} />
        )}
        <div className="lg:hidden">
          <LanguageToggle />
        </div>
        <UserMenu />
      </div>
    </header>
  );
}
